import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // 默认重定向
  {
    path: '/',
    redirect: '/fateReport'
  },
  // Line 登录回调页面
  {
    path: '/line-callback',
    name: 'LineCallback',
    component: () => import('@/views/login/LineCallback.vue')
  },
  // 支付回调页面
  {
    path: '/payment-callback',
    name: 'PaymentCallback',
    component: () => import('@/views/payment/PaymentCallback.vue')
  },
  {
    path: '/fateReport',
    name: 'FateReport',
    meta: {
      showTab: true
    },
    component: () => import('@/views/fateReport/FateReport.vue')
  },
  // {
  //   path: '/course',
  //   name: 'Course',
  //   meta: {
  //     showTab: true
  //   },
  //   component: () => import('@/views/course/CoursePage.vue')
  // },
  // {
  //   path: '/mall',
  //   name: 'Mall',
  //   meta: {
  //     showTab: true
  //   },
  //   component: () => import('@/views/mall/MallPage.vue')
  // },
  {
    path: '/my',
    name: 'My',
    meta: {
      showTab: true
    },
    component: () => import('@/views/my/MyPage.vue')
  },
  {
    path: '/terms-policy',
    name: 'TermsPolicy',
    meta: {
      showTab: false
    },
    component: () => import('@/views/termsPolicy/TermsPolicy.vue')
  },
  {
    path: '/fate-report-share/:td',
    name: 'FateReportShare',
    meta: {
      showTab: false
    },
    component: () => import('@/views/shareModule/FateReportShare.vue')
  },

  // {
  //   path: '/order-list',
  //   name: 'OrderList',
  //   meta: {
  //     showTab: true
  //   },
  //   component: () => import('@/views/order/OrderList.vue')
  // },
  // {
  //   path: '/order-details/:id',
  //   name: 'OrderDetails',
  //   meta: {
  //     showTab: true
  //   },
  //   component: () => import('@/views/order/OrderDetails.vue')
  // },
  // 404 页面重定向
  {
    path: '/:pathMatch(.*)*',
    redirect: '/fateReport'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
